function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);
/* Logo/CH/Wordmark Horizontal.svg: width 143px x height 16px */

var DlsLogoWordmarkHorizontal =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsLogoWordmarkHorizontal, _CustomElement2);

  var _super = _createSuper(DlsLogoWordmarkHorizontal);

  function DlsLogoWordmarkHorizontal() {
    _classCallCheck(this, DlsLogoWordmarkHorizontal);

    return _super.apply(this, arguments);
  }

  _createClass(DlsLogoWordmarkHorizontal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"143\" height=\"16\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 143 16\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12.89 3.014L11.32 4.87c-1.416-1.225-2.334-1.53-3.5-1.53-2.487 0-4.018 1.875-4.018 4.745 0 2.908 1.568 4.783 3.98 4.783 1.435 0 2.315-.534 3.75-1.74l1.57 1.818c-1.685 1.587-3.197 2.277-5.282 2.277-4.23 0-6.755-3.062-6.755-7.157 0-3.999 2.43-7.08 6.774-7.08 2.086 0 3.464.632 5.052 2.028m3.124 6.984c0 1.895 1.015 3.1 2.565 3.1 1.53 0 2.545-1.205 2.545-3.1 0-1.874-1.015-3.1-2.545-3.1-1.55 0-2.565 1.226-2.565 3.1zm7.636 0c0 3.1-2.105 5.206-5.071 5.206-2.985 0-5.09-2.105-5.09-5.206 0-3.1 2.105-5.204 5.09-5.204 2.966 0 5.07 2.105 5.07 5.204zm1.229 4.899h2.487V1.311H24.88zm4.269 0h2.488V1.311h-2.488zm6.203-6.027h4.573c-.095-1.301-.86-2.125-2.22-2.125-1.32 0-2.085.862-2.353 2.125zm5.607 2.89l1.397 1.53c-1.435 1.454-2.776 1.914-4.363 1.914-3.157 0-5.128-2.03-5.128-5.148 0-3.023 1.836-5.262 4.917-5.262 2.985 0 4.574 1.875 4.574 4.88 0 .305-.02.765-.039.975h-7.022c.21 1.416 1.052 2.45 2.755 2.45 1.148 0 1.76-.383 2.909-1.34zm7.257-4.861c-1.645 0-2.526 1.397-2.526 3.1s.88 3.08 2.507 3.08c.956 0 1.646-.42 2.66-1.511l1.645 1.378c-1.397 1.74-2.64 2.258-4.343 2.258-2.947 0-4.995-1.972-4.995-5.206 0-3.233 2.105-5.204 5.052-5.204 1.55 0 2.794.44 4.095 1.856l-1.55 1.531C49.65 7.13 48.98 6.9 48.216 6.9m11.104 7.863a6.724 6.724 0 01-2.201.364c-1.99 0-2.775-.938-2.775-2.756V7.013h-1.74V5.12h1.74V2.096h2.488V5.12h2.335v1.894h-2.335v5.052c0 .69.325.9.976.9.287 0 .593-.02 1.225-.173l.286 1.971m.981.133h2.487V5.119H60.3zM73.219 5.12l-3.33 9.777h-3.024l-3.31-9.778h2.621l.976 3.196c.516 1.703.938 3.138 1.263 4.44a91.952 91.952 0 011.244-4.44l.976-3.196h2.584m2.434 3.751h4.573c-.095-1.301-.861-2.125-2.22-2.125-1.32 0-2.085.862-2.353 2.125zm5.607 2.89l1.397 1.53c-1.435 1.454-2.776 1.914-4.363 1.914-3.157 0-5.128-2.03-5.128-5.148 0-3.023 1.836-5.262 4.917-5.262 2.985 0 4.574 1.875 4.574 4.88 0 .305-.02.765-.039.975h-7.023c.21 1.416 1.053 2.45 2.756 2.45 1.148 0 1.76-.383 2.909-1.34zm19.034 3.118h-2.678V8.869H91.55v6.009h-2.679V1.292h2.679v5.319h6.066V1.292h2.678v13.586m3.716-6.028h4.573c-.095-1.3-.861-2.124-2.22-2.124-1.32 0-2.086.862-2.353 2.125zm5.607 2.89l1.396 1.53c-1.435 1.455-2.775 1.914-4.362 1.914-3.157 0-5.129-2.029-5.129-5.147 0-3.024 1.837-5.263 4.917-5.263 2.986 0 4.574 1.876 4.574 4.88 0 .306-.019.765-.038.976h-7.023c.211 1.416 1.053 2.449 2.755 2.449 1.15 0 1.761-.383 2.91-1.34zm8.693-.842v-.575l-1.645.345c-1.474.306-2.45.65-2.45 1.569 0 .612.555.976 1.493.976 1.262 0 2.602-.613 2.602-2.315zm2.373-2.622v6.602h-2.24v-1.015c-.592.823-1.644 1.34-3.156 1.34-1.856 0-3.502-.804-3.502-2.794 0-2.258 2.009-3.042 4.229-3.444l2.296-.421v-.23c0-.957-.708-1.492-1.837-1.492-1.34 0-2.028.612-3.042 1.588l-1.57-1.435c1.225-1.454 2.64-2.2 4.574-2.2 2.813 0 4.248 1.434 4.248 3.501z\"/><path d=\"M35.352 8.87h4.573c-.095-1.301-.86-2.125-2.22-2.125-1.32 0-2.085.862-2.353 2.125zm5.607 2.89l1.397 1.53c-1.435 1.455-2.776 1.914-4.363 1.914-3.157 0-5.128-2.03-5.128-5.148 0-3.023 1.836-5.262 4.917-5.262 2.985 0 4.574 1.875 4.574 4.88 0 .305-.02.765-.039.975h-7.022c.21 1.416 1.052 2.45 2.755 2.45 1.148 0 1.76-.383 2.909-1.34zm81.377 3.118h2.488V1.292h-2.488zm10.182-.134a6.746 6.746 0 01-2.2.364c-1.99 0-2.775-.938-2.775-2.756V6.994h-1.741V5.1h1.741V2.076h2.488V5.1h2.333v1.894h-2.333v5.052c0 .689.324.899.976.899.287 0 .593-.019 1.224-.172l.287 1.97m9.744.135h-2.488V8.927c0-1.283-.631-2.01-1.818-2.01-1.148 0-1.971.843-1.971 2.067v5.894h-2.487V1.292h2.487v4.687c.612-.746 1.55-1.205 2.775-1.205 2.277 0 3.502 1.416 3.502 3.406v6.698zM62.998 2.498c0 .828-.632 1.454-1.455 1.454a1.426 1.426 0 01-1.453-1.454c0-.83.631-1.455 1.453-1.455.823 0 1.455.626 1.455 1.455\"/></g></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-logo-wordmark-horizontal';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsLogoWordmarkHorizontal;
}(_CustomElement);

export { DlsLogoWordmarkHorizontal as default };
DlsLogoWordmarkHorizontal.define();